import { FC } from "react";
import { IEntityChangeLogDetail } from "../../interfaces/endpoints/IEntityChangeLog.types";
import { prettyJson } from "./changeHistoryJson";

// The engineer's view of a row: technical ids and the raw JSON, folded away by default.
const TechnicalDetails: FC<{ row: IEntityChangeLogDetail }> = ({ row }) => (
  <details className="mb-5 text-xs text-gray-500">
    <summary className="cursor-pointer">Të dhënat teknike</summary>
    <p className="mt-2">
      {row.entityName} #{row.entityId} · burimi {row.source ?? "—"} · kërkesa{" "}
      <span className="font-mono">{row.correlationId}</span>
      {row.recordedAction !== row.action && <> · regjistruar si {row.recordedAction}</>}
    </p>
    {row.changes && (
      <pre className="mt-2 p-3 bg-gray-50 border border-gray-200 rounded overflow-x-auto max-h-60">
        {prettyJson(row.changes)}
      </pre>
    )}
    {row.previousState && (
      <pre className="mt-2 p-3 bg-gray-50 border border-gray-200 rounded overflow-x-auto max-h-60">
        {prettyJson(row.previousState)}
      </pre>
    )}
  </details>
);

export default TechnicalDetails;
